// extracted by mini-css-extract-plugin
export default {"settings":"PasswordSettings_settings__gd76g","settings__title":"PasswordSettings_settings__title__GNKbb","toggle":"PasswordSettings_toggle__DcxsL"};